import { Link } from "react-router-dom";
import { useClassrooms } from "../data/ClassroomContext";
import { useLessons } from "../data/LessonsContext";
import useProgress from "../data/useProgress";
import { COMPLETED } from "../data/progressStore";
import { CheckIcon } from "../components/Icons";
import { LessonAction, LessonMeta, orderForToday } from "../components/LessonState";
import ui from "../components/ui.module.css";
import { LessonsNotReady, OfflineLessonsNotice, teachingContext } from "./Week";

// What to teach now: for each subject this week, the lesson in progress or
// the next one. The whole week lives under Week.
const UpNext = ({ lessons, getProgress }) => {
  const next = lessons.subjects
    .map((subject) => ({ subject, lesson: orderForToday(subject.lessons, getProgress)[0] }))
    .filter(({ lesson }) => getProgress(lesson.id)?.status !== COMPLETED);
  // A lesson already underway comes first.
  const ordered = orderForToday(
    next.map(({ lesson }) => lesson),
    getProgress
  ).map((lesson) => next.find((item) => item.lesson === lesson));

  if (!ordered.length) {
    return (
      <div className={`${ui.card} ${ui.stack}`}>
        <span className={`${ui.state} ${ui.done}`}>
          <CheckIcon />
          All done
        </span>
        <h2 className={ui.cardTitle}>You've taught every Week {lessons.week} lesson.</h2>
        <Link to="/week" className={`${ui.button} ${ui.secondary}`}>
          See Week {lessons.week}
        </Link>
      </div>
    );
  }

  return (
    <section className={ui.stack} aria-labelledby="up-next">
      <h2 id="up-next" className={ui.cardTitle}>
        Up next
      </h2>
      <ul className={ui.list}>
        {ordered.map(({ subject, lesson }, index) => (
          <li key={subject.key} className={`${ui.card} ${index === 0 ? ui.featured : ""} ${ui.stack}`}>
            <p className={ui.eyebrow}>
              {[subject.name, lesson.studyArea].filter(Boolean).join(" · ")}
            </p>
            <h3 className={ui.cardTitle}>{lesson.title}</h3>
            <LessonMeta lesson={lesson} />
            <LessonAction lesson={lesson} record={getProgress(lesson.id)} primary={index === 0} />
          </li>
        ))}
      </ul>
    </section>
  );
};

const Today = () => {
  const lessons = useLessons();
  const progress = useProgress();
  const { active } = useClassrooms();

  return (
    <div className={ui.page}>
      <div className={ui.stack}>
        <h1 className={ui.title}>Today</h1>
        <p className={ui.eyebrow}>
          {teachingContext({ className: active.name, week: lessons.week })}
        </p>
      </div>
      <div className={ui.quickActions}>
        {/* Near the top so teachers find it without scrolling past every lesson. */}
        <Link to="/tablets" className={`${ui.button} ${ui.secondary}`}>
          Set up learner tablet
        </Link>
      </div>
      <OfflineLessonsNotice lessons={lessons} />
      {LessonsNotReady({ lessons, className: active.name }) || (
        <UpNext lessons={lessons} getProgress={progress.get} />
      )}
    </div>
  );
};

export default Today;
